<template>
	<div v-loading="loading">
		<div style="display: flex;align-items: center;background-color: #fff;padding: 20px;">
			<el-button :loading="loadingExport" @click="exportDesign"
				style="background-color: #242754 ;color: #fff;">导出装修数据</el-button>

			<el-upload :http-request="uploadFlie" action="" :on-change="handleJsonFileChange" accept=".json"
				:show-file-list="false" class="upload-demo" :file-list="fileList">
				<el-button :loading="loadingImport" style="background-color: #242754 ;color: #fff;">导入装修数据</el-button>
			</el-upload>
		</div>

		<div style="background-color: #fff;padding: 20px;margin-top: 20px;">
			<div style="display: flex;align-items: center;flex-wrap: wrap;">
				<div style="font-weight: bold;font-size: 16px;">
					模板筛选
				</div>
				<div style="display: flex;flex-wrap: wrap;">
					<div @click="selectType = item.value;getDesignTemplate()" :style="{
						backgroundColor:item.value == selectType?'#242754':'#fff',
						color:item.value == selectType?'#ffffff':'#000000',
						border:item.value == selectType?'none':'solid 1px #a6a6a6',
					}" style="padding: 4px 20px;cursor: pointer;margin-left: 10px;font-size: 14px;border-radius: 10px;"
						v-for="(item,index) in options" :key="index">
						{{item.label}}
					</div>
				</div>
			</div>
			<div style="display: flex;flex-wrap: wrap;min-height: 200px;margin-top: 10px;">
				<div v-for="(item,index) in list" :key="index" style="margin: 8px;cursor: pointer;">
					<div @mouseleave.stop.prevent="scrollElementsToTop('webimg' + index)"
						@mouseenter.stop.prevent="scrollElementsToBottom('webimg' + index)" :class="'webimg' + index"
						style="width: 300px;height: 380px;overflow-y: scroll;border: solid 1px #bababa;">
						<!-- https://admin.shop910.com -->
						<img style="width: 100%;" :src="'https://admin.shop910.com' + item.image" />
					</div>

					<div style="display: flex;margin-top: 4px;justify-content: space-between;">
						<div @click="previewWeb(item)"
							style="border: solid 1px #bababa;font-size: 14px;border-radius: 2px;width: 146px;height: 34px;display: flex;align-items: center;justify-content: center;">
							预览模板
						</div>
						<div @click="importTemp(item)"
							style="background-color: #242754;color: #ffffff;font-size: 14px;border-radius: 2px;width: 146px;height: 36px;display: flex;align-items: center;justify-content: center;">
							导入模板
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		animate,
		createTimeline,
		createTimer,
		waapi
		// ...other methods
	} from 'animejs';

	import {
		getNewDesignSetting,
		getDesignAllSetting,
		getDesignSave,
		designTemplate,
		designTemplateDesign
	} from '../../api/all.js'
	export default {
		data() {
			return {
				list: [],
				loading: false,
				selectType: "zh",
				options: [{
						value: 'zh',
						label: "综合"
					},
					{
						value: 'bag',
						label: "包包"
					},
					{
						value: 'sb',
						label: "手表"
					},
					{
						value: 'shoe',
						label: "鞋子"
					},
					{
						value: 'zb',
						label: "珠宝"
					},
					{
						value: 'mz',
						label: "美妆"
					},
					{
						value: 'cr',
						label: "成人"
					},
					{
						value: 'hw',
						label: "黑五"
					},
					{
						value: 'xn',
						label: "虚拟产品"
					}
				],
				fileList: [],
				loadingExport: false,
				jsonData: null,
				fileName: '',
				loadingImport: false,
				isScroll: false

			}
		},
		mounted() {
			this.getDesignTemplate()
		},
		methods: {
			scrollElementsToTop(selector) {
				this.isScroll = false
				const elements = document.querySelectorAll('.' + selector);
				elements.forEach(element => {
					// element.scrollTop = '0px'
					element.scrollTo({
						top: 0,
						behavior: 'smooth' // 平滑滚动
					})
				})
			},
			// 滚动到底部（平滑效果）
			scrollElementsToBottom(selector, duration = 4000) {
				let that = this
				// 获取所有匹配元素
				that.isScroll = true
				const elements = document.querySelectorAll('.' + selector);
				elements.forEach(element => {
					// 计算需要滚动的距离
					const start = element.scrollTop;
					const distance = element.scrollHeight - element.clientHeight - start;

					// 如果不需要滚动，直接返回
					if (distance <= 0) return;

					// 开始滚动动画
					const startTime = performance.now();

					const animateScroll = function(currentTime) {
						if (that.isScroll) {
							const elapsed = currentTime - startTime;
							const progress = Math.min(elapsed / duration, 1);

							// 使用缓动函数（easeOutCubic）
							const easeProgress = 1 - Math.pow(1 - progress, 3);
							element.scrollTop = start + distance * easeProgress;

							if (progress < 1) {
								requestAnimationFrame(animateScroll);
							}
						}

					};
					if (that.isScroll) {
						requestAnimationFrame(animateScroll);
					}
				});
			},
			async importTemp(item) {


				this.$confirm( < div >
					<div>
					1、 导入模板， 会覆盖原装修模板， 且无法恢复！ </div> <div >
					2、 此导入模板操作， 不会影响商品、 订单、 会员等其他设置！ </div>  </div > , '正在进行导入装修模板操作， 请注意：', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
					try {
						this.loading = true
						let wsid = this.$cookies.get("wsid")
						let data = await designTemplateDesign({
							wsid,
							id: item.id
						})

						let list = data.data.data.list
						let obj = {
							pcNav: JSON.stringify(this.initSetData(JSON.parse(list.pcNav))),
							phoneNav: JSON.stringify(this.initSetData(JSON.parse(list.phoneNav))),
							pcFooter: JSON.stringify(this.initSetData(JSON.parse(list.pcFooter))),
							phoneFooter: JSON.stringify(this.initSetData(JSON.parse(list
								.phoneFooter))),
							home: JSON.stringify(this.initSetData(JSON.parse(list.home))),
							detail: JSON.stringify(this.initSetData(JSON.parse(list.detail))),
							classifyList: JSON.stringify(this.initSetData(JSON.parse(list
								.classifyList))),
							globalDialogList: JSON.stringify(this.initSetData(JSON.parse(list
								.globalDialogList))),
							goodsConfig: list.goodsConfig ? list.goodsConfig : '[]',
							all_setting: data.data.data.all_setting.data,
						}
						console.log('objobjobj', obj)
						this.jsonData = obj
						await this.importJsonSave()
						this.loading = false
					} catch (e) {
						this.loading = false
					}
				}).catch(() => {

				});

			},
			previewWeb(item) {
				console.log('item', item)
				window.open('https://' + item.remote)

			},
			async getDesignTemplate() {
				try {
					let that = this
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let data = await designTemplate({
						type: this.selectType,
						wsid
					})
					this.list = data.data.data
					this.$forceUpdate()
					console.log('data', data)
					this.loading = false

				} catch (e) {
					this.loading = false
				}
			},

			uploadFlie() {

			},
			handleJsonFileChange(file) {
				if (!file) return

				this.fileName = file.name

				const reader = new FileReader()
				reader.onload = (event) => {
					try {
						this.jsonData = JSON.parse(event.target.result)
						console.log('jsonData', this.jsonData)
						this.importJsonSave()
						// this.$message.success('JSON文件解析成功')
					} catch (error) {
						this.$message.error('JSON文件格式错误，请检查文件内容')
						console.error('JSON解析错误:', error)
					}
				}
				reader.onerror = () => {
					this.$message.error('文件读取失败')
				}
				reader.readAsText(file.raw) // 注意使用 file.raw
			},

			async importJsonSave() {
				try {
					this.loadingImport = true
					let wsid = this.$cookies.get("wsid")
					let data = await getDesignSave({
						wsid,
						data: {
							pcNav: this.jsonData.pcNav,
							phoneNav: this.jsonData.phoneNav,
							pcFooter: this.jsonData.pcFooter,
							phoneFooter: this.jsonData.phoneFooter,
							home: this.jsonData.home,
							detail: this.jsonData.detail,
							classifyList: this.jsonData.classifyList,
							globalDialogList: this.jsonData.globalDialogList,
							goodsConfig: this.jsonData.goodsConfig,
						},
					})

					console.log('this.setConfigList', this.setConfigList)
					await getDesignAllSetting({
						data: this.jsonData.all_setting,
						wsid
					})
					this.loadingImport = false
					window.location.reload()
					this.$message.success('模板应用成功')
				} catch (e) {
					this.loadingImport = false
				}


			},

			exportJson(data, filename = 'design.json') {
				// 将数据转换为JSON字符串
				const jsonString = JSON.stringify(data, null, 2)

				// 创建Blob对象
				const blob = new Blob([jsonString], {
					type: 'application/json'
				})

				// 创建下载链接
				const url = URL.createObjectURL(blob)
				const link = document.createElement('a')
				link.href = url
				link.download = filename

				// 触发下载
				document.body.appendChild(link)
				link.click()

				// 清理
				document.body.removeChild(link)
				URL.revokeObjectURL(url)
			},


			async exportDesign() {
				try {
					this.loadingExport = true
					let wsid = this.$cookies.get("wsid")
					const data = await getNewDesignSetting({
						wsid
					})
					this.loadingExport = false
					let list = data.data.data.list

					let obj = {
						pcNav: JSON.stringify(this.initSetData(JSON.parse(list.pcNav))),
						phoneNav: JSON.stringify(this.initSetData(JSON.parse(list.phoneNav))),
						pcFooter: JSON.stringify(this.initSetData(JSON.parse(list.pcFooter))),
						phoneFooter: JSON.stringify(this.initSetData(JSON.parse(list.phoneFooter))),
						home: JSON.stringify(this.initSetData(JSON.parse(list.home))),
						detail: JSON.stringify(this.initSetData(JSON.parse(list.detail))),
						classifyList: JSON.stringify(this.initSetData(JSON.parse(list.classifyList))),
						globalDialogList: JSON.stringify(this.initSetData(JSON.parse(list.globalDialogList))),
						goodsConfig: list.goodsConfig,
						all_setting: data.data.data.all_setting.data,
					}
					
					
					console.log(JSON.parse(data.data.data.all_setting.data))

					this.exportJson(obj)

				} catch (e) {
					this.loadingExport = false
				}
			},

			initSetData(list) {
				// 第一层
				list.forEach(item => {
					item.children.forEach(childItem => {
						// 第二层
						childItem.children.forEach(twoChildItem => {
							// 第三层
							if (twoChildItem.compontChildren.length > 0) {
								if (twoChildItem.compontChildren[0].compoentName ==
									'wmGoodsList') {
									twoChildItem.compontChildren[0].data = {
										classfiy: [],
									}
								}
							}
						})
					})
				})
				return list
			}
		}
	}
</script>

<style scoped>

</style>